<template>
  <div>
    <nav-bar/>
    <buy-art/>
    <div class="on-the-left padded">
        <p>
            <div class="question">How do I interact with this if I don't have any ETH (the currency of the Ethereum network)?</div>
            <div class="answer">The first thing you will need to do is buy yourself some ETH. 
                You do this buy creating an account at a cryptocurrency exchange such as <a href="https://gemini.com/" target="_blank">Gemini</a>, <a href="https://www.coinbase.com/" target="_blank">Coinbase</a> or <a href="https://www.bittrex.com/" target="_blank">Bittrex</a>. 
                You can then transfer money to your account to exchange for ETH. 
                Once you have some ETH on an exchange the next thing to do is create your own ETH account that you control the private keys for. 
                One way to do this is by using the browser plugin <a href="https://www.metamask.io">Metamask</a>. 
                Once you've created an Ethereum account in Metamask, you can transfer your funds there from the exchange.
                Now when you browse to the dapp home page <a href="https://art30.neilmendoza.com" target="_blank">art30.neilmendoza.com</a> if you are logged into Metamask you will automatically be able to interact with the DApp.</div>
        </p>

        <p>
            <div class="question">How much money will I make if someone buys Art 3.0 after me?</div>
            <div class="answer">If someone buys Art 3.0 after you there will be a 40% profit, so if you paid 100 ETH you will receive 140 ETH in the next sale.</div>
        </p>

        <p>
            <div class="question">Someone bought Art 3.0 after me but I didn't get any ETH sent to me. Why?</div>
            <div class="answer">Due to smart contract <a href="https://solidity.readthedocs.io/en/v0.4.24/common-patterns.html" target="_blank">security considerations</a> your ETH will not be sent to you automatically.
            You can withdraw it on the <b-link to="collector-admin">collector admin page</b-link>.</div>
        </p>

        <p>
            <div class="question">The price increases by 50%, why do I only make a 40% profit?</div>
            <div class="answer">2.5% goes to a charity of the exhibiting institution's choice and 7.5% goes to the artist.</div>
        </p>

        <p>
            <div class="question">How can I get Art 3.0 shipped to me?</div>
            <div class="answer">You must be the current owner and the previous person that received it must have had it in their possesion for a minimum of four weeks.
            If the piece is currently exhibited it will not be shipped until the end of the exhibition.
            Once you request shipping your future funds will be locked, they will be unlocked once you send it on to the next requestor or back to the artist</div>
        </p>

        <p>
            <div class="question">What about exhibitions?</div>
            <div class="answer">If you request shipment of Art 3.0, you agree to work with the artist to exhibit the piece.
            The artist will organize all logistics related to exhibitions.</div>
        </p>

        <p>
            <div class="question">How does shipping work?</div>
            <div class="answer">If you are eligible to have the item shipped, the artist will contact you using the contact details you entered when you purchased Art 3.0.</div>
        </p>

        <p>
            <div class="question">How was the piece fabricated?</div>
            <div class="answer">The body was CNC milled from a solid block of aluminium and anodized.
                The front and back are milled from polycarbonate. 
                The PCB was fabricated in two parts and is based on an ESP32 microcontroller.</div>
        </p>
        
        <p>
            <div class="question">What is blockchain?</div>
            <div class="answer">Check out <a href="https://www.wired.com/story/guide-blockchain/" target="_blank">this Wired article</a>.</div>
        </p>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import BuyArt from '@/components/BuyArt'

export default {
  name: 'faq',
  components: {
    'nav-bar': NavBar,
    'buy-art': BuyArt
  }
}
</script>

<style scoped>
.question {
    font-weight: bold;
}

.answer {
}

.on-the-left {
    text-align: left;
}

.padded {
    padding: 0 10pc;
}
</style>


// WEBPACK FOOTER //
// src/components/Faq.vue